import React, { useState } from 'react';

interface LomavisCopyableTextProps {
  /** The text content to display and copy */
  text: string;
  /** Show success message after copying */
  showSuccessMessage?: boolean;
  /** Custom success message */
  successMessage?: string;
  /** Timeout for success message (in ms) */
  successTimeout?: number;
  /** Show background for the text */
  showBackground?: boolean;
}

/**
 * Atom: LomavisCopyableText
 *
 * A text component with copy functionality.
 * Displays text content with a copy button on the right side.
 */
export const LomavisCopyableText: React.FC<LomavisCopyableTextProps> = ({
  text,
  showSuccessMessage = true,
  successMessage,
  successTimeout = 2000,
  showBackground = false
}) => {

  const [isSuccess, setIsSuccess] = useState(false);

  const handleCopy = (event: React.MouseEvent) => {
    event.stopPropagation();
    void (async () => {
      try {
        await navigator.clipboard.writeText(text);
        
        if (showSuccessMessage) {
          setIsSuccess(true);
          setTimeout(() => {
            setIsSuccess(false);
          }, successTimeout);
        }
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    })();
  };

  return (
    <div className="d-flex align-items-center">
      <p
        className={`mb-0 me-2 text-break rounded ${
          showBackground ? 'bg-light px-2 py-1' : 'pe-2'
        }`}
      >
        {text}
      </p>
      <button 
        className="btn btn-sm p-0 border-0 flex-shrink-0"
        onClick={handleCopy}
        type="button"
        title="Copy"
      >
        {isSuccess ? (
          <i className="fa-duotone fa-solid fa-check text-success"></i>
        ) : (
          <i className="fa-duotone fa-solid fa-copy text-muted"></i>
        )}
      </button>
    </div>
  );
};
